export default __webpack_public_path__ + "static/media/fat_free_food.267e067e.svg";